<agpr-take-over-panel
    [id]="'manageSourcesDialog'"
    header="Source.manageDialog.header"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    (visibleChange)="cancel()"
    [hideSlideOverlay]="hideSlideOverlay"
    [responsiveWidth]="true"
    [minPanelWidth]="1000"
    [maxPanelWidth]="1200"
>
    <div class="agpr-manageSources">
        <div class="agpr-manageSources-groups">
            <div class="agpr-manageSources-groups-header">
                <div class="agpr-manageSources-titlebar">
                    <h2>{{ 'SourceGroups' | localize }}</h2>
                    <div class="agpr-manageSources-titlebar-buttons">
                        <div class="agpr-manageSources-sort">
                            <agpr-button
                                [id]="'manageSourcesDialog_sourceGroups_sortDirection'"
                                [style]="buttonTypes.icon"
                                [icon]="sourceGroupSortOrder === sortOrder.ascending ? 'fa-regular fa-arrow-down-short-wide' : 'fa-regular fa-arrow-up-wide-short'"
                                [tooltip]="'SourceGroups.sort'"
                                tooltipPosition="top"
                                (click)="toggleSourceGroupSortOrder()"
                            ></agpr-button>
                            <agpr-icon-dropdown
                                [id]="'manageSourcesDialog_sourceGroups_sortOption'"
                                [options]="sourceGroupSortMenuOptions"
                                [applyHighlight]="true"
                                [alignPanelRight]="true"
                                inputTooltip="SourceGroups.sort.options"
                                inputTooltipPosition="top"
                                [(ngModel)]="selectedSourceGroupSortOption"
                                (ngModelChange)="sortSourceGroups($event)"
                            >
                            </agpr-icon-dropdown>
                        </div>
                        <agpr-button
                            [id]="'manageSourcesDialog_sourceGroups_create'"
                            class="agpr-manageSources-create"
                            [style]="buttonTypes.icon"
                            [icon]="'fa-regular fa-duotone fa-square-plus'"
                            [tooltip]="'SourceGroups.create'"
                            tooltipPosition="top"
                            (click)="createGroup()"
                        ></agpr-button>
                    </div>
                </div>
                <div class="agpr-manageSources-search">
                    <span
                        [attr.aria-hidden]="true"
                        class="fa-regular fa-duotone fa-magnifying-glass"
                    ></span>
                    <agpr-text-input
                        [id]="'manageSourcesDialog_sourceGroups_search'"
                        placeholder="SourceGroups.search"
                        [(ngModel)]="sourceGroupSearch"
                        (ngModelChange)="filterSourceGroups()"
                    ></agpr-text-input>
                </div>
                <div
                    [id]="'manageSourcesDialog_sourceGroups_allSources'"
                    class="agpr-manageSources-card agpr-manageSources-card-group agpr-manageSources-card-group-all"
                    [ngClass]="{'agpr-manageSources-card--selected': activeSourceGroup === allSourcesGroup}"
                    (click)="setActiveSourceGroup(allSourcesGroup)"
                    [attr.tabIndex]="0"
                >
                    <div class="agpr-manageSources-card-selectedBar"></div>
                    <div class="agpr-manageSources-card-content">
                        <div class="agpr-manageSources-card-name">{{ 'Sources.all' | localize }}</div>
                        <div class="agpr-manageSources-card-sources">
                            {{ allSources.length }} {{ (allSources.length === 1 ? 'Source' : 'Sources') | localize }}
                        </div>
                    </div>
                </div>
                <agpr-button
                    [id]="'manageSourcesDialog_sourceGroups_selectToggle'"
                    class="agpr-manageSources-selectAll"
                    [style]="buttonTypes.link"
                    [label]="allGroupsSelected ? 'selectNone' : 'selectAll'"
                    (click)="toggleSelectAllGroups()"
                ></agpr-button>
            </div>
            <div class="agpr-manageSources-groups-list">
                <agpr-message
                    *ngIf="!this.filteredSourceGroups.length"
                    [severity]="messageSeverityEnum.noContent"
                >
                    {{ 'SourceGroups.noSourceGroupsFound' | localize }}
                </agpr-message>
                <agpr-scroll-panel>
                    <ul class="agpr-manageSources-groups-list-inner">
                        <li
                            [id]="'manageSourcesDialog_sourceGroups_groupCard_' + i"
                            *ngFor="let group of filteredSourceGroups; let i = index;"
                            class="agpr-manageSources-card agpr-manageSources-card-group agpr-contextMenu-parent"
                            [ngClass]="{'agpr-manageSources-card--selected': activeSourceGroup === group}"
                            (agprClickUnless)="setActiveSourceGroup(group)"
                            [agprClickUnlessSelectors]="['agpr-button', 'agpr-checkbox']"
                            dndDropzone
                            (dndDrop)="onSourceDrop($event, group.id)"
                        >
                            <div class="agpr-manageSources-card-selectedBar"></div>
                            <agpr-checkbox
                                [id]="'manageSourcesDialog_sourceGroups_groupCard_' + i + '_selected'"
                                [binary]="true"
                                [(ngModel)]="group.selected"
                                (ngModelChange)="checkForSelected()"
                            ></agpr-checkbox>
                            <div class="agpr-manageSources-card-content">
                                <div class="agpr-manageSources-card-header">
                                    <span class="agpr-manageSources-card-name">{{ group.name }}</span>
                                    <!-- An automation agent is watching this group - as marked in the monitoring sidebar -->
                                    @if (group.liveAgentCount) {
                                        <span
                                            role="img"
                                            class="agpr-manageSources-card-liveAgentIcon fa-solid fa-signal-stream"
                                            [agprTooltip]="group.liveAgentTooltip"
                                            tooltipPosition="top"
                                            [attr.aria-label]="group.liveAgentTooltip"
                                        ></span>
                                    }
                                </div>
                                <div class="agpr-manageSources-card-sources">
                                    {{ group.sources.length }} {{ (group.sources.length === 1 ? 'Source' : 'Sources') | localize }}
                                </div>
                            </div>
                            <div class="agpr-manageSources-card-info">
                                <span
                                    class="fa-regular fa-circle-info"
                                    [agprTooltip]="'Source.manageDialog.sourceInformation' | localize: {
                                        createdBy: group.createdBy,
                                        createdDate: group.created,
                                        modifiedBy: group.modifiedBy,
                                        modifiedDate: group.modified
                                    }"
                                    tooltipPosition="right"
                                ></span>
                            </div>
                            <ul class="agpr-contextMenu bottom right">
                                @if (hasAgenticFeature) {
                                    <li>
                                        <agpr-button
                                            [id]="'manageSourcesDialog_sourceGroups_groupCard_' + i + '_addLiveAgent'"
                                            [style]="buttonTypes.contextMenu"
                                            icon="fa-kit-duotone fa-agpr-ai-generic"
                                            tooltip="AutomationAgents.source.addLiveAgent"
                                            tooltipPosition="top"
                                            (click)="addLiveAgent(group)"
                                        ></agpr-button>
                                    </li>
                                }
                                <li>
                                    <agpr-button
                                        [id]="'manageSourcesDialog_sourceGroups_groupCard_' + i + '_edit'"
                                        [style]="buttonTypes.contextMenu"
                                        [icon]="'fa-regular fa-duotone fa-pen'"
                                        [tooltip]="'SourceGroups.edit'"
                                        tooltipPosition="top"
                                        (click)="editGroup(group)"
                                    ></agpr-button>
                                </li>
                                <li>
                                    <agpr-button
                                        [id]="'manageSourcesDialog_sourceGroups_groupCard_' + i + '_delete'"
                                        [style]="buttonTypes.contextMenu"
                                        [icon]="'fa-regular fa-duotone fa-trash-can'"
                                        [tooltip]="'SourceGroups.delete'"
                                        tooltipPosition="top"
                                        (click)="deleteSourceGroup(group)"
                                    ></agpr-button>
                                </li>
                            </ul>
                        </li>
                    </ul>

                </agpr-scroll-panel>
            </div>
            <div class="agpr-manageSources-groups-footer">
                <agpr-button
                    [id]="'manageSourcesDialog_sourceGroups_delete'"
                    [label]="'SourceGroups.delete.multiple'"
                    [style]="buttonTypes.tertiary"
                    [disabled]="!selectedSourceGroups.length"
                    (click)="deleteSelectedSourceGroups()"
                ></agpr-button>
            </div>
        </div>
        <div class="agpr-manageSources-sources">
            <div class="agpr-manageSources-sources-header">
                <div class="agpr-manageSources-titlebar">
                    <h2>{{ activeSourceGroup?.name }}</h2>
                    <div class="agpr-manageSources-titlebar-buttons">
                        <div class="agpr-manageSources-sort">
                            <agpr-button
                                [id]="'manageSourcesDialog_sources_sortDirection'"
                                [style]="buttonTypes.icon"
                                [icon]="sourceSortOrder === sortOrder.ascending ? 'fa-regular fa-arrow-down-short-wide' : 'fa-regular fa-arrow-up-wide-short'"
                                [tooltip]="'Sources.sort'"
                                tooltipPosition="top"
                                (click)="toggleSourceSortOrder()"
                            ></agpr-button>
                            <agpr-icon-dropdown
                                [id]="'manageSourcesDialog_sources_sortOption'"
                                [options]="sourceSortMenuOptions"
                                [applyHighlight]="true"
                                inputTooltip="Sources.sort.options"
                                inputTooltipPosition="top"
                                [(ngModel)]="selectedSourceSortOption"
                                (ngModelChange)="sortSources($event)"
                            >
                            </agpr-icon-dropdown>
                        </div>
                        <agpr-button
                            [id]="'manageSourcesDialog_sources_create'"
                            class="agpr-manageSources-create"
                            [style]="buttonTypes.icon"
                            [icon]="'fa-regular fa-duotone fa-square-plus'"
                            [tooltip]="'Sources.create'"
                            tooltipPosition="top"
                            (click)="createSource()"
                        ></agpr-button>
                    </div>
                </div>
                <div class="agpr-manageSources-search">
                    <span
                        [attr.aria-hidden]="true"
                        class="fa-regular fa-duotone fa-magnifying-glass"
                    ></span>
                    <agpr-text-input
                        [id]="'manageSourcesDialog_sources_search'"
                        placeholder="Sources.search"
                        [(ngModel)]="sourceSearch"
                        (ngModelChange)="filterSources()"
                    ></agpr-text-input>
                </div>
                <agpr-button
                    [id]="'manageSourcesDialog_sources_selectToggle'"
                    class="agpr-manageSources-selectAll"
                    [style]="buttonTypes.link"
                    (click)="toggleSelectAllSources()"
                    [label]="allSourcesSelected ? 'selectNone' : 'selectAll'"
                ></agpr-button>
            </div>
            <div class="agpr-manageSources-sources-list">
                <agpr-message
                    *ngIf="!this.filteredSources.length"
                    [severity]="messageSeverityEnum.noContent"
                >
                    {{ 'Sources.noSourcesFound' | localize }}
                </agpr-message>
                <cdk-virtual-scroll-viewport
                    *ngIf="this.filteredSources.length"
                    class="agpr-manageSources-sources-list-virtualScroll agpr-virtualScroll"
                    [itemSize]="69"
                    minBufferPx="650"
                    maxBufferPx="1300"
                >
                    <ul>
                        <li
                            [id]="'manageSourcesDialog_sources_sourceCard_' + i"
                            *cdkVirtualFor="let source of filteredSources; let i = index;"
                            class="agpr-manageSources-card agpr-manageSources-card-source agpr-contextMenu-parent"
                            [dndDraggable]="source.id"
                            (dndStart)="onSourceDragStart(source.selected)"
                            (dndEnd)="cleanupAfterDragCompleted($event)"
                        >
                            <div class="agpr-manageSources-card-selectedBar"></div>
                            <agpr-checkbox
                                [id]="'manageSourcesDialog_sources_sourceCard_' + i + '_selected'"
                                [binary]="true"
                                [(ngModel)]="source.selected"
                                (ngModelChange)="checkForSelected()"
                            ></agpr-checkbox>
                            <div class="agpr-manageSources-card-content">
                                <div class="agpr-manageSources-card-header">
                                    <span class="agpr-manageSources-card-name">{{ source.name }}</span>
                                    <span class="agpr-manageSources-card-name-type">({{ 'Common.journodex.' + source.type | localize }})</span>
                                </div>
                                <div
                                    class="agpr-manageSources-card-sourceGroups"
                                    [pTooltip]="source.groupsTooltip"
                                    tooltipPosition="top"
                                    tooltipStyleClass="agpr-manageSources-card-sourceGroups-tooltip"
                                >
                                    <span class="agpr-manageSources-card-sourceGroups-label">{{ 'Sources.inGroup' | localize }}</span>
                                    <span
                                        *ngFor="let group of source.sourceGroups; let last = last;"
                                    >
                                        <span class="agpr-manageSources-card-sourceGroups-name">
                                            {{ group.name }}
                                        </span>
                                        <span *ngIf="!last">, </span>
                                    </span>
                                    <span *ngIf="!source.sourceGroups">{{ 'Sources.none' | localize }}</span>
                                </div>
                            </div>
                            <div class="agpr-manageSources-card-info">
                                <span
                                    class="fa-regular fa-circle-info"
                                    [agprTooltip]="'Source.manageDialog.sourceInformation' | localize: {
                                        createdBy: source.createdBy,
                                        createdDate: source.created,
                                        modifiedBy: source.modifiedBy,
                                        modifiedDate: source.modified
                                    }"
                                    tooltipPosition="left"
                                ></span>
                            </div>
                            <ul class="agpr-contextMenu bottom right">
                                <li>
                                    <agpr-button
                                        [id]="'manageSourcesDialog_sources_sourceCard_' + i + '_edit'"
                                        [style]="buttonTypes.contextMenu"
                                        [icon]="'fa-regular fa-duotone fa-pen'"
                                        [tooltip]="'Sources.edit'"
                                        tooltipPosition="top"
                                        (click)="editSource(source)"
                                    ></agpr-button>
                                </li>
                                <li *ngIf="activeSourceGroup !== allSourcesGroup">
                                    <agpr-button
                                        [id]="'manageSourcesDialog_sources_sourceCard_' + i + '_remove'"
                                        [style]="buttonTypes.contextMenu"
                                        [icon]="'fa-regular fa-duotone fa-square-xmark'"
                                        [tooltip]="'Sources.remove' | localize: {group: activeSourceGroup.name}"
                                        tooltipPosition="left"
                                        (click)="removeSource(source)"
                                    ></agpr-button>
                                </li>
                                <li *ngIf="activeSourceGroup === allSourcesGroup">
                                    <agpr-button
                                        [id]="'manageSourcesDialog_sources_sourceCard_' + i + '_delete'"
                                        [style]="buttonTypes.contextMenu"
                                        [icon]="'fa-regular fa-duotone fa-trash-can'"
                                        [tooltip]="'Sources.delete'"
                                        tooltipPosition="left"
                                        (click)="deleteSource(source)"
                                    ></agpr-button>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </cdk-virtual-scroll-viewport>
            </div>
            <div class="agpr-manageSources-sources-footer">
                <agpr-button
                    [id]="'manageSourcesDialog_sources_delete'"
                    *ngIf="activeSourceGroup === allSourcesGroup"
                    [label]="'Sources.delete.multiple'"
                    [style]="buttonTypes.tertiary"
                    [disabled]="!selectedSources.length"
                    (click)="deleteSelectedSources()"
                ></agpr-button>
                <agpr-button
                    [id]="'manageSourcesDialog_sources_remove'"
                    *ngIf="activeSourceGroup !== allSourcesGroup"
                    [label]="'Sources.removeFromGroup'"
                    [style]="buttonTypes.tertiary"
                    [disabled]="!selectedSources.length"
                    (click)="removeSourcesFromGroup()"
                ></agpr-button>
                <agpr-button
                    [id]="'manageSourcesDialog_sources_add'"
                    [label]="'Sources.addToGroup'"
                    [style]="buttonTypes.tertiary"
                    [disabled]="!selectedSources.length"
                    (click)="addSourcesToGroup()"
                ></agpr-button>
            </div>
        </div>
    </div>
    <ng-template #takeOverFooterRight>
        <agpr-button
            [id]="'manageSourcesDialog_done'"
            [label]="'done'"
            [style]="buttonTypes.primary"
            (click)="closeDialog()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>